/**
 * CalenderIcon component.
 *
 * @component
 * @param {object} props - The component props.
 * @param {string} [props.color] - The color of the SVG path. Defaults to "white".
 * @param {number | string} [props.size] - The size of the SVG. Defaults to 16.
 * @param {string} [props.className] - Additional CSS class name for the SVG element.
 * @param {any} [props.onClick] - The click event handler for the icon.
 * @returns {JSX.Element} - The PencilIcon SVG component.
 */
const CalenderIcon = ({ color, size, onClick, className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? "20"}
      height={size ?? "20"}
      viewBox="0 0 20 20"
      fill="none"
      onClick={onClick}
      className={className ?? ""}
    >
      <path
        d="M5.625 2.5V4.375M14.375 2.5V4.375M2.5 15.625V6.25C2.5 5.21447 3.33947 4.375 4.375 4.375H15.625C16.6605 4.375 17.5 5.21447 17.5 6.25V15.625M2.5 15.625C2.5 16.6605 3.33947 17.5 4.375 17.5H15.625C16.6605 17.5 17.5 16.6605 17.5 15.625M2.5 15.625V9.375C2.5 8.33947 3.33947 7.5 4.375 7.5H15.625C16.6605 7.5 17.5 8.33947 17.5 9.375V15.625"
        stroke={color ?? "#07070C"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CalenderIcon;
